type FormGuardState = {
  /**
   * Глобальный флаг наличия несохранённых изменений на текущей странице.
   *
   * Управляется формами/карточками через entities/formGuard.
   */
  isDirty: boolean;
};

type FormGuardStore = {
  getState: () => FormGuardState;
  setState: (partial: Partial<FormGuardState>) => void;
};

let state: FormGuardState = {
  isDirty: false,
};

/**
 * Признак несохранённых изменений хранится вне рендера: его читает блокировщик переходов
 * в момент самого перехода, поэтому подписка на изменения store'у не нужна.
 */
export const formGuardStore: FormGuardStore = {
  getState: () => state,
  setState: (partial) => {
    state = { ...state, ...partial };
  },
};
